/**
 * Created by Kamil on 23.05.2017.
 */
/**
 * Created by Kamil on 23.05.2017.
 */
import React, {Component} from 'react';
import './ProductCatalog.css';
import ProductCard from "./ProductCard";
import CategoryFilter from "./CategoryFilter";
import SearchFilter from "./SearchFilter";
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'; // ES6
import axios from 'axios';

class ProductCatalog extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.verifySearchPhrase = this.verifySearchPhrase.bind(this);
        this.state = {products: [], activeFilterID: 0, searchPhrase: ''};
    }

    componentDidMount() {
        var _this = this;
        if (window.devMode) {
            _this.setState({
                products: window.productsMockup
            });
        } else {
            this.serverRequest =
                axios
                    .get('/wp-json/wp/v2/products-api?per_page=100')
                    .then(function (result) {
                        _this.setState({
                            products: result.data
                        });
                    })
        }
    }

    componentWillUnmount() {
        this.serverRequest.abort();
    }

    handleChange(filterID) {
        this.setState({activeFilterID: filterID});
    };

    handleSearch(newPhrase) {
        this.setState({searchPhrase: newPhrase});
    }

    verifySearchPhrase(product) {
        return product.title.rendered.toLocaleLowerCase().match(this.state.searchPhrase.toLocaleLowerCase()) || product.excerpt.rendered.toLocaleLowerCase().match(this.state.searchPhrase.toLocaleLowerCase());
    }

    render() {
        var self = this;

        var listProducts = this.state.products.map(function (product, index) {
            if ((self.state.activeFilterID == 0 || self.state.activeFilterID == product['products_categories'][0]) && self.verifySearchPhrase(product))
                return (
                    <ProductCard key={index} product={product}/>
                )
        });

        return (
            <div className="ProductCatalog">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-lg-5">
                            <CategoryFilter changeFilter={this.handleChange} activeFilterID={this.state.activeFilterID}/>
                            <SearchFilter search={this.handleSearch}/>
                        </div>
                        <div id="style-1" className="col-12 col-lg-7 listProduct">
                            <ReactCSSTransitionGroup
                                transitionName="example"
                                transitionEnterTimeout={500}
                                transitionLeaveTimeout={300}>
                            {listProducts}
                            </ReactCSSTransitionGroup>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ProductCatalog;


// WEBPACK FOOTER //
// ./src/components/ProductCatalog.js